import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import CategoriesField from '@/components/categories/CategoriesField.vue';
import CategoryField from '@/components/categories/CategoryField.vue';
import {
  impactAreaItems,
  Initiative,
  InitiativeStatus,
} from '@/models/initiative.model';
import { ref, PropType, watch } from 'vue';
import RichTextField from '@/components/common/RichTextField.vue';
import MediaList from '@/components/media/MediaList.vue';
import { MediaPurpose } from '@/models/media.model';
import AddressField from '@/components/common/AddressField.vue';
import ContactField from '@/components/common/ContactField.vue';
import { Contact } from '@/models/contact.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'InitiativeContentForm',
  props: {
  modelValue: { type: Object as PropType<Initiative>, required: true },
},
  emits: [
  'update:modelValue',
  'update:published',
  'remove-contact',
  'update:status',
],
  setup(__props, { emit: __emit }) {

const props = __props;
const value = ref<Initiative>({ ...(props.modelValue || {}) });

const emit = __emit;

const update = () => {
  emit('update:modelValue', value.value);
};
watch(
  () => props.modelValue,
  () => {
    Object.assign(value.value, props.modelValue);
  },
  { deep: true },
);

const togglePublished = async (published: boolean) => {
  if (value.value.id !== -1) {
    emit('update:published', { ...value.value, published: !published });
  }
  value.value.published = !published;
};

const removeContact = (item: Contact) => {
  emit('remove-contact', item);
};

const openURL = () => {
  window.open(`/#/initiative/${value.value.publicUUID}/edit`, 'new');
};

const setPublished = async () => {
  emit('update:status', { ...value.value, status: InitiativeStatus.Published });
};
const setReadyForReview = async () => {
  emit('update:status', {
    ...value.value,
    status: InitiativeStatus.ReadyForReview,
  });
};

function checkUrl(url: string) {
  window.open(url, '_new');
}

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (value.value.createdByUser && value.value.status === _unref(InitiativeStatus).Published)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          color: value.value.published ? 'success' : 'warning',
          class: "ma-4 pa-4"
        }, {
          default: _withCtx(() => [
            _cache[15] || (_cache[15] = _createTextVNode(" This initiative was created by content editor ")),
            _createElementVNode("strong", null, _toDisplayString(value.value.createdByUser?.firstName) + " " + _toDisplayString(value.value.createdByUser?.lastName), 1),
            _cache[16] || (_cache[16] = _createTextVNode(". ")),
            (!value.value.published)
              ? (_openBlock(), _createElementBlock("i", _hoisted_1, "This initiative still needs to be published"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["color"]))
      : _createCommentVNode("", true),
    (
      value.value.createdByUser &&
      value.value.status === _unref(InitiativeStatus).ReadyForPublishing
    )
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 1,
          color: "warning",
          class: "ma-4 pa-4"
        }, {
          default: _withCtx(() => [
            _cache[17] || (_cache[17] = _createTextVNode(" This initiative was created by content editor ")),
            _createElementVNode("strong", null, _toDisplayString(value.value.createdByUser?.firstName) + " " + _toDisplayString(value.value.createdByUser?.lastName), 1),
            _cache[18] || (_cache[18] = _createTextVNode(". Check the initiative and set it to ")),
            _cache[19] || (_cache[19] = _createElementVNode("em", null, "\"published\"", -1)),
            _cache[20] || (_cache[20] = _createTextVNode(" or return it to the user with status ")),
            _cache[21] || (_cache[21] = _createElementVNode("em", null, "\"ready for review\"", -1)),
            _cache[22] || (_cache[22] = _createTextVNode(". "))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (
      value.value.createdByUser &&
      [_unref(InitiativeStatus).Editing, _unref(InitiativeStatus).ReadyForReview].includes(
        value.value.status,
      )
    )
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 2,
          color: "warning",
          class: "ma-8 pa-8"
        }, {
          default: _withCtx(() => [
            _cache[23] || (_cache[23] = _createTextVNode(" This initiative was created by content editor ")),
            _createElementVNode("strong", null, _toDisplayString(value.value.createdByUser?.firstName) + " " + _toDisplayString(value.value.createdByUser?.lastName), 1),
            _cache[24] || (_cache[24] = _createTextVNode(". Please wait until it has status ")),
            _cache[25] || (_cache[25] = _createElementVNode("em", null, "\"Shift Review\"", -1)),
            _cache[26] || (_cache[26] = _createTextVNode(" before doing anything with it. "))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (value.value.publicUUID)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 3,
          onClick: openURL,
          color: "info",
          style: {"max-width":"200px","position":"absolute","top":"20px","right":"60px"}
        }, {
          default: _withCtx(() => _cache[27] || (_cache[27] = [
            _createTextVNode("Open Public URL")
          ])),
          _: 1
        }))
      : _createCommentVNode("", true),
    ([_unref(InitiativeStatus).ReadyForPublishing].includes(value.value.status))
      ? (_openBlock(), _createBlock(_component_v_container, { key: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    (value.value.status === _unref(InitiativeStatus).ReadyForPublishing)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          class: "",
                          onClick: setReadyForReview,
                          color: "warning",
                          block: ""
                        }, {
                          default: _withCtx(() => _cache[28] || (_cache[28] = [
                            _createTextVNode("Ready for Review")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, null, {
                  default: _withCtx(() => [
                    (value.value.status === _unref(InitiativeStatus).ReadyForPublishing)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          onClick: setPublished,
                          color: "success",
                          block: ""
                        }, {
                          default: _withCtx(() => _cache[29] || (_cache[29] = [
                            _createTextVNode("Published")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (value.value.createdByUser && value.value.status !== _unref(InitiativeStatus).Published)
      ? (_openBlock(), _createBlock(_component_v_timeline, {
          key: 5,
          class: "ma-16",
          direction: "horizontal",
          density: "compact",
          "fill-dot": false,
          size: "x-small",
          align: "start"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_timeline_item, {
              "dot-color": 
        value.value.status === _unref(InitiativeStatus).Editing ? 'primary' : '#efefef'
      
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_chip, {
                  variant: "flat",
                  density: "compact",
                  color: 
          value.value.status === _unref(InitiativeStatus).Editing ? 'primary' : '#808080'
        
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.status_editing')), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }, 8, ["dot-color"]),
            _createVNode(_component_v_timeline_item, {
              "dot-color": 
        value.value.status === _unref(InitiativeStatus).ReadyForReview ? 'primary' : '#efefef'
      
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_chip, {
                  variant: "flat",
                  density: "compact",
                  color: 
          value.value.status === _unref(InitiativeStatus).ReadyForReview
            ? 'primary'
            : '#808080'
        
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.status_review_long')), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }, 8, ["dot-color"]),
            _createVNode(_component_v_timeline_item, {
              "dot-color": 
        value.value.status === _unref(InitiativeStatus).ReadyForPublishing
          ? 'primary'
          : '#efefef'
      
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_chip, {
                  variant: "flat",
                  density: "compact",
                  color: 
          value.value.status === _unref(InitiativeStatus).ReadyForPublishing
            ? 'primary'
            : '#808080'
        
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.status_publishing_long')), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }, 8, ["dot-color"]),
            _createVNode(_component_v_timeline_item, {
              "dot-color": 
        value.value.status === _unref(InitiativeStatus).Published ? 'primary' : '#efefef'
      
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_chip, {
                  variant: "flat",
                  density: "compact",
                  color: 
          value.value.status === _unref(InitiativeStatus).Published ? 'primary' : '#808080'
        
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.status_published')), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }, 8, ["dot-color"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "9" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: value.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value.value.title) = $event)),
              onChange: update,
              label: "Title",
              required: "",
              "hide-details": ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "pt-6" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              block: "",
              disabled: value.value.status !== _unref(InitiativeStatus).Published,
              onClick: _cache[1] || (_cache[1] = () => togglePublished(value.value.published)),
              color: !value.value.published ? 'success' : 'warning'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(value.value.published ? 'Un-publish' : 'Publish'), 1)
              ]),
              _: 1
            }, 8, ["disabled", "color"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: value.value.quizTitle,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((value.value.quizTitle) = $event)),
              onChange: update,
              label: "Quiz Title",
              required: "",
              "hide-details": "",
              counter: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "9" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: value.value.website,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((value.value.website) = $event)),
              onChange: update,
              placeholder: "https://",
              label: "Website URL",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "pt-6" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              block: "",
              color: "info",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (checkUrl(value.value.website))),
              disabled: value.value.website == ''
            }, {
              default: _withCtx(() => _cache[30] || (_cache[30] = [
                _createTextVNode("Check")
              ])),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { dense: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              label: "Recommended",
              density: "compact",
              modelValue: value.value.recommended,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((value.value.recommended) = $event)),
              onChange: update
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: value.value.favourite,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((value.value.favourite) = $event)),
              label: "Favourite count",
              density: "compact",
              onChange: update
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(AddressField, {
      modelValue: value.value.address,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((value.value.address) = $event)),
      onChange: update
    }, null, 8, ["modelValue"]),
    (value.value.contacts)
      ? (_openBlock(), _createBlock(ContactField, {
          key: 6,
          modelValue: value.value.contacts,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((value.value.contacts) = $event)),
          onChange: update,
          onRemove: removeContact
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_select, {
      modelValue: value.value.impactArea,
      "onUpdate:modelValue": [
        _cache[9] || (_cache[9] = ($event: any) => ((value.value.impactArea) = $event)),
        update
      ],
      items: _unref(impactAreaItems),
      label: "Area",
      required: ""
    }, null, 8, ["modelValue", "items"]),
    _createVNode(CategoryField, {
      main: "",
      modelValue: value.value.mainCategory,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((value.value.mainCategory) = $event)),
      onChange: update,
      disabled: "",
      label: "Main Category"
    }, null, 8, ["modelValue"]),
    (value.value.categories)
      ? (_openBlock(), _createBlock(CategoriesField, {
          key: 7,
          modelValue: value.value.categories,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((value.value.categories) = $event)),
          onChange: update
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(RichTextField, {
      label: "Short description",
      height: 200,
      modelValue: value.value.shortDescription,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((value.value.shortDescription) = $event)),
      hint: "Used in stories when users choose their interest",
      onChange: update,
      media: __props.modelValue.media
    }, null, 8, ["modelValue", "media"]),
    _createVNode(RichTextField, {
      label: "Description",
      modelValue: value.value.description,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((value.value.description) = $event)),
      hint: "Used as the full text of the action",
      onChange: update,
      media: __props.modelValue.media
    }, null, 8, ["modelValue", "media"]),
    _createVNode(MediaList, {
      modelValue: value.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((value).value = $event)),
      onChange: update,
      required: [_unref(MediaPurpose).BackgroundImage, _unref(MediaPurpose).Main]
    }, null, 8, ["modelValue", "required"])
  ], 64))
}
}

})